import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import AHDate from "_shared/dates/date";
import { Link as RouterLink } from "react-router";
import { useSession } from "users/__session/session-context";
import { useGetProposalsTheReaderLeftQuery } from "work/proposals/_api/proposal-api";

const Section = styled("section")(({ theme }) => ({
  margin: theme.spacing(2),
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

const Rows = styled("ul")(({ theme }) => ({
  listStyle: "none",
  margin: theme.spacing(1, 0, 0),
  padding: 0,
  "& > li": {
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "space-between",
    padding: theme.spacing(1, 0),
  },
  "& > li + li": {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

/**
 * The proposals the reader has left, under their archived proposals (#5833). Each opens the proposal
 * as it was when they left it. Nothing is drawn for a reader who has left nothing.
 */
export default function ProposalsYouLeft() {
  const session = useSession();
  const { data } = useGetProposalsTheReaderLeftQuery({ session });
  const proposalsLeft = data ?? [];

  if (proposalsLeft.length === 0) return null;

  return (
    <Section aria-labelledby="proposals-you-left-title">
      <Typography id="proposals-you-left-title" variant="h6" component="h2">
        Proposals you left
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Each shows the proposal as it was when you left it.
      </Typography>
      <Rows>
        {proposalsLeft.map((proposal) => (
          <li key={proposal.id} data-testid="proposal-you-left-row">
            <Link component={RouterLink} to={`/proposals/archived/view/${proposal.id}/details`}>
              {proposal.name}
            </Link>
            <Typography variant="body2" color="text.secondary">
              Left on {AHDate.fromJSON(proposal.frozenAt)?.format("MM/DD/YYYY")}
            </Typography>
          </li>
        ))}
      </Rows>
    </Section>
  );
}
